import { createNavigation } from 'next-intl/navigation';
import { stripLocaleFromPathIfPresent } from '@core/constants/locales.constants';
import { routing } from './routing';

// These must be used instead of the Next ones.
// https://next-intl-docs.vercel.app/docs/routing/navigation#apis
const {
  Link,
  redirect,
  usePathname,
  useRouter,
  getPathname,
  permanentRedirect,
} = createNavigation(routing);

/**
 * Without this check the redirect adds the locale twice
 * I'm not sure why this has started to happen and why
 * it doesn't happen on other projects, even though they
 * use the same version on next-intl
 * @param args: Parameters<typeof permanentRedirect>[0]
 * @returns permanentRedirect
 */
const permanentRedirectWithDeDuplicatedLocales = ({
  href,
  ...rest
}: Parameters<typeof permanentRedirect>[0]) =>
  permanentRedirect({
    ...rest,
    href: typeof href === 'string' ? stripLocaleFromPathIfPresent(href) : href,
  });

export {
  Link,
  redirect,
  usePathname,
  useRouter,
  getPathname,
  permanentRedirect,
  permanentRedirectWithDeDuplicatedLocales,
};
